"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNotifications = exports.default = void 0;
var _PulseApiHelper = _interopRequireDefault(require("./PulseApiHelper"));
var _get = _interopRequireDefault(require("lodash/get"));
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

const updateNotifications = async function () {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const url = new URL(`${_PulseApiHelper.default.getHostUrl()}/ans/v1/notifications`);
  const response = await fetch(url.href, {
    method: 'PUT',
    headers: _PulseApiHelper.default.getDefaultHeaders(),
    body: JSON.stringify({
      notifications: {
        notification: params
      }
    })
  });
  //TODO UpdateNotifications to throw , then the caller fucntion has to catch this error
  if (!response.ok) {
    throw new Error(`UpdateNotificationsService failed, HTTP status ${response.status}`);
  }
  const data = await response.json();
  return (0, _get.default)(data, 'notifications', []);
};
exports.updateNotifications = updateNotifications;
var _default = {
  updateNotifications
};
exports.default = _default;